import { ADD_HISTORY_TEAM, REMOVE_HISTORY_TEAM, ADD_HISTORY_COUNTRY, REMOVE_HISTORY_COUNTRY, ADD_HISTORY_LEAGUE, REMOVE_HISTORY_LEAGUE } from "./actionTypes";

const initialState = {
  historyLeagues: [],
  historyMatches: [],
  historyCountries: [],
  historyTeams: [],
};

export const SearchHistoryReducer = (
  state: any = initialState,
  action: any
) => {
  switch (action.type) {
    case ADD_HISTORY_COUNTRY:

      if (!state.historyCountries?.map((league: any) => league.country).includes(action.payload.country)) {
        return {
          ...state,
          historyCountries: [...state.historyCountries, action.payload],
        };
      }
      return state;
    case REMOVE_HISTORY_COUNTRY:
      return {
          ...state,
          historyCountries: state.historyCountries?.filter((league: any) => league.countryId !== action.payload.countryId),
        };
    case ADD_HISTORY_LEAGUE:

      if (!state.historyLeagues?.map((league: any) => league.id).includes(action.payload.id)) {
        return {
          ...state,
          historyLeagues: [...state.historyLeagues, action.payload],
        };
      }
      return state;
    case REMOVE_HISTORY_LEAGUE:
      return {
        ...state,
        historyLeagues: state.historyLeagues?.filter((league: any) => league.id !== action.payload.id),
      };
    case ADD_HISTORY_TEAM:
      if (!state.historyTeams?.map((team: any) => team.id).includes(action.payload.id)) {
        return {
          ...state,
          historyTeams: [...state.historyTeams, action.payload],
        };
      }
      return state;
    case REMOVE_HISTORY_TEAM:
      return {
        ...state,
        historyTeams: state.historyTeams?.filter((team: any) => team.id !== action.payload.id),
      };
    default:
      return state;
  }
};

export default SearchHistoryReducer;
